import React, { useEffect } from "react";

export default function SelfGradeModal({
    children,
    onSubmit,
    modalId,
    dataBackDrop,
    dataKeyboard,
    modalClassName,
    dialogClassName,
    contentClassName,
    backdropClassName,
}) {
    useEffect(() => {
        if (!backdropClassName || typeof document === "undefined") {
            return undefined;
        }

        const modalElement = document.getElementById(modalId);

        if (!modalElement) {
            return undefined;
        }

        const addBackdropClass = () => document.body.classList.add(backdropClassName);
        const removeBackdropClass = () => document.body.classList.remove(backdropClassName);

        modalElement.addEventListener("shown.bs.modal", addBackdropClass);
        modalElement.addEventListener("hidden.bs.modal", removeBackdropClass);

        return () => {
            modalElement.removeEventListener("shown.bs.modal", addBackdropClass);
            modalElement.removeEventListener("hidden.bs.modal", removeBackdropClass);
            document.body.classList.remove(backdropClassName);
        };
    }, [backdropClassName, modalId]);

    return (

        <div className={`modal fade custom-modal-top ${modalClassName || ""}`.trim()} id={modalId} tabIndex="-1" role="dialog" data-backdrop={dataBackDrop} data-keyboard={dataKeyboard} aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ margin: 0 }}>
            <div className={`modal-dialog modal-dialog-centered selfgrade-modal-dialog ${dialogClassName || ""}`.trim()} role="document">
                <div className={`modal-content selfgrade-modal-content ${contentClassName || ""}`.trim()}>

                    <form className="form fv-plugins-bootstrap fv-plugins-framework" onSubmit={onSubmit}>
                        {children}
                    </form>

                </div>
            </div>
        </div>

    )
}
